import { defineComponent as _defineComponent } from 'vue'
import { DataInstance, Meetings, Userspaces } from '@busy-human/opt-library'
import { ref, onMounted, watch } from 'vue'
type Props = {
    request: Meetings.Model
    user: DataInstance<Userspaces.Model>
}
type Emits = {
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'meeting-rescheduled',
  props: {
    request: null,
    user: null
  },
  emits: ["progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    request: Meetings.Model
    user: DataInstance<Userspaces.Model>
}

var moment = require('moment'); // require





const isPayer = ref()
const meetingDate = ref("")
const meetingTime = ref("")
const meetingvalue = ref("")

onMounted(async() => {
    if(props.user.$id == props.request.collector)
        isPayer.value = false
    else
        isPayer.value = true

    meetingDate.value = moment(props.request.startTime).format("MMMM D")
    meetingTime.value = moment(props.request.startTime).format("h:mm a")
    // console.log(props.invite)
})

const proceed = () => {
    emit('progress');
}


const __returned__ = { moment, props, emit, isPayer, meetingDate, meetingTime, meetingvalue, proceed, DataInstance, Meetings, Userspaces, ref, onMounted, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})